module.exports = __webpack_public_path__ + "img/gift4-01-c07-t2.8817b6c4.png";